import { createSlice } from '@reduxjs/toolkit';

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState: {
    value: [],
    // Tracks whether /featureflags has been fetched at least once. Route
    // gates use this to avoid redirecting to /404 during the initial paint
    // before the flags are hydrated (which would otherwise lock out users
    // who hit Refresh on a flagged page).
    fetched: false
  },
  reducers: {
    setFeatureFlags: (state, action) => {
      state.value = action.payload;
      state.fetched = true;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setFeatureFlags } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
